module.exports = __webpack_public_path__ + "static/media/escuela-icon--white.8ae6d1ca.svg";